import { GroupTier } from '@evidia/shared';
import { useGroupSettings } from '../../hooks/useGroupSettings';
import { useUpgradeAccountModal } from '../../pages/MorePage/useUpgradeAccountModal';
import { Stepper } from './Stepper';
import { UpgradeMessageContainer } from './UpgradeMessageContainer';
import { FooterButton, Message } from './styles';

export const UpgradeAccountWidget = () => {
	const { data: groupSettings } = useGroupSettings();
	const { upgradeAccountModal, openUpgradeAccountModal } = useUpgradeAccountModal();

	if (!groupSettings || groupSettings?.tier !== GroupTier.STARTER) {
		return null;
	}

	return (
		<>
			<UpgradeMessageContainer isWidget>
				<Message>Evidujte neomezeně s premium</Message>
				<Stepper
					steps={groupSettings.maxStudentsInSchoolPerMonth}
					passedSteps={groupSettings.currentUsageStudentsInSchoolPerMonth ?? 0}
					prefix="žáků"
					suffix="za měsíc"
				/>
				<FooterButton
					type="primary"
					onClick={() =>
						openUpgradeAccountModal({
							message: 'Vylepšte si účet a evidujte neomezeně',
							title: 'Vylepšit účet',
							stepper: {
								prefix: 'žáků',
								suffix: 'za měsíc',
								passedSteps: groupSettings.currentUsageStudentsInSchoolPerMonth ?? 0,
								steps: groupSettings.maxStudentsInSchoolPerMonth,
							},
						})
					}
				>
					Vylepšit
				</FooterButton>
			</UpgradeMessageContainer>
			{upgradeAccountModal}
		</>
	);
};
